<template>
  <div class="main">
    <div class="pageTitle">
      <p>项目维护</p>
    </div>
    <div class="searchArea">
      <el-form
        label-position="left"
        size="small"
        label-width="80px"
        class="searchForm"
        :inline="true"
        @submit.native.prevent>
        <el-row>
          <el-form-item label="关键字:">
            <el-input v-model="listQuery.Parameters.keyword" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="searchTable">查询</el-button>
            <el-button size="small" @click="createNewModel">新增</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div class="tableContainer" style="top: 110px;">
      <div class="tableContent">
        <el-table :data="dataList" border stripe>
          <el-table-column type="index" width="80" label="序号"></el-table-column>
          <el-table-column prop="serialNumber"  width="120" label="项目编号"></el-table-column>
          <el-table-column prop="serialNumber" label="项目名称">
            <template slot-scope="props">
                <el-button type="text" size="mini" @click="setDetail(props.row)">
                  {{props.row.name}}
                </el-button>
                <span style="color:red" v-if="props.row.removed">（已停用）</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="typeName" label="项目类型" width="120"></el-table-column> -->
          <el-table-column prop="ownerUserName" label="负责人" width="120"></el-table-column>
          <el-table-column prop="contractPrice" label="签约金额(万)" width="120"></el-table-column>
          <el-table-column prop="statusText" label="项目状态" width="120"></el-table-column>
          <!-- <el-table-column label="操作" width="120">
            <template slot-scope="props">
              <el-button size="mini" @click="setDetail(props.row)">设置</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="tablePagesNumber">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.PagingInfo.currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="listQuery.PagingInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.PagingInfo.totalCount"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="项目维护"
      :visible.sync="projectTypeVisible"
      :close-on-click-modal="false"
      width="500px"
      @close="closeDialog()"
      :close-on-press-escape="false">
      <div class="modalForm">
        <el-form
          :model="projectForm"
          label-position="left"
          ref="projectForm"
          size="small"
          :rules="rules"
          label-width="100px"
          :show-message="false">
          <el-form-item label="项目编号:" prop="serialNumber">
            <el-input v-model="projectForm.serialNumber" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="项目名称:" prop="name">
            <el-input v-model="projectForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="项目类型:" prop="typeId">
             <el-select v-model="projectForm.typeId" placeholder="请选择" clearable>
            <el-option v-for="item in projectTypeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option> 
          </el-select>
          </el-form-item>-->
          <el-form-item label="负责人:" prop="ownerUserName">
            <el-input v-model="projectForm.ownerUserName" autocomplete="off"></el-input>
            <div class="input_chooseBtn">
              <el-button type="text" size="medium" @click="chooseOwnerUser">选择</el-button>
              <el-button type="text" size="medium" @click="clearOwnerUser">清除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="签约金额(万):" prop="contractPrice">
            <el-input
              v-model="projectForm.contractPrice"
              autocomplete="off"
              @change="contractPriceChange">
              <template slot="append">万</template>
            </el-input>
          </el-form-item>
          <el-form-item label="项目状态:" prop="statusId">
            <el-select v-model="projectForm.statusId" placeholder="请选择" clearable>
              <el-option
                v-for="item in statusList"
                :key="item.id"
                :label="item.text"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="remove()" class="delete_btn" v-if="isEdit==true">停用</el-button>
        <el-button size="small" @click="save()">保存</el-button>
        <el-button size="small" @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
    <chooseUser ref="chooseUser" :propsData="chooseUserPropsData" @chooseUserInfo="chooseUserCallback"></chooseUser>
  </div>
</template>
<script>
import chooseUser from "../common/chooseUser";
export default {
  name: "project",
  components: { chooseUser },
  props: [],
  data() {
    return {
      projectForm: {
        name: "",
        id: "",
        serialNumber: "",
        // typeId:"",
        typeName: "",
        ownerUserId: "",
        ownerUserName: "",
        contractPrice: "",
        statusId: ""
      },
      chooseUserPropsData: {
        visible: false
      },

      dataList: [],
      statusList: [],
      projectTypeList: [],
      listQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 10,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: "",
          includeRemoved:true
        }
      },
      selectlistQuery: {
        PagingInfo: {
          currentPage: 1,
          totalPage: 0,
          pageSize: 1000,
          totalCount: 0
        },
        OrderBy: "",
        Parameters: {
          keyword: ""
        }
      },
      rules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        // typeId: [
        //   { required: true, message: "请选择项目类型", trigger: "blur" }
        // ],
        serialNumber: [
          { required: true, message: "请输入项目编号", trigger: "blur" }
        ]
      },
      projectTypeVisible: false,
      isEdit: false
    };
  },
  mounted() {
    this.getDataList();
    this.getDictionary();
    // this.getprojectTypeList();
  },
  methods: {
    setDetail(currentLine) {
      this.$router.push({
        path: "/project/projectDetail",
        query: { id: currentLine.id, name: currentLine.name }
      });
    },

    //选择负责人
    chooseOwnerUser() {
      this.$refs.chooseUser.show();
    },
    clearOwnerUser() {
      this.projectForm.ownerUserName = "";
      this.projectForm.ownerUserId = "";
    },
    chooseUserCallback(args) {
      this.projectForm.ownerUserName = args.name;
      this.projectForm.ownerUserId = args.id;
    },

    contractPriceChange() {
      if (isNaN(this.projectForm.contractPrice)) {
        this.projectForm.contractPrice = "0";
      }
    },

    getDictionary() {
      let keys = ["ProjectStatus"];
      this.$dictionaryApi.getDictionaryWithItemsBundle(keys).then(res => {
        if (res.data.successful) {
          this.statusList = res.data.data[0].dictionaryItem;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    getDataList() {
      this.$projectApi.getProjectList(this.listQuery).then(res => {
        if (res.data.successful) {
          this.dataList = res.data.data.data;
          this.listQuery.PagingInfo.totalCount =
            res.data.data.pagingInfo.totalCount;
        } else {
          this.$alert(res.data.message, "提示");
        }
      });
    },
    getprojectTypeList() {
      this.$projectApi.getProjectTypeList(this.selectlistQuery)
        .then(res => {
          if (res.data.successful) {
            this.projectTypeList = res.data.data.data;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
    },
    // getDataInfo(data) {
    //   let id = data.id;
    //   this.projectForm = {
    //     name: "",
    //     id: "",
    //     serialNumber: "",
    //     // typeId:"",
    //     typeName: "",
    //     ownerUserId: "",
    //     ownerUserName: "",
    //     contractPrice: "",
    //     statusId: ""
    //   };
    //   this.$projectApi.getProject(id).then(res => {
    //     this.treeData = [];
    //     if (res.data.successful) {
    //       this.projectForm = res.data.data;
    //       this.isEdit = true;
    //       this.projectTypeVisible = true;
    //     } else {
    //       this.$alert(res.data.message, "提示");
    //     }
    //   });
    // },
    searchTable() {
      this.getDataList();
    },
    createNewModel() {
      this.isEdit = false;
      this.projectForm = {
        name: "",
        id: "",
        serialNumber: "",
        // typeId:"",
        typeName: "",
        ownerUserId: "",
        ownerUserName: "",
        contractPrice: "",
        statusId: ""
      };
      this.projectTypeVisible = true;
    },
    save() {
      this.$refs.projectForm.validate((valid,data) => 
      {
         if (valid == false)
        {
          this.$uiHelper.showValidationMessage(valid,data);
          return;
        }

        let submitForm = JSON.parse(JSON.stringify(this.projectForm));
        if (this.isEdit) 
        {
          this.$projectApi.updateProject(submitForm).then(res => 
          {
            if (res.data.successful) 
            {
              this.getDataList();
              this.projectTypeVisible = false;
            } else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
        } 
        else 
        {
          delete submitForm.id;
          delete submitForm.createTime;
          this.$projectApi.createProject(submitForm).then(res => 
          {
            if (res.data.successful) 
            {
              this.getDataList();
              this.projectTypeVisible = false;
            } 
            else 
            {
              this.$alert(res.data.message, "提示");
            }
          });
        }
      });
    },
    remove() {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let id = this.projectForm.id;
        this.$projectApi.removeProject(id).then(res => {
          if (res.data.successful) {
            this.getDataList();
            this.projectTypeVisible = false;
          } else {
            this.$alert(res.data.message, "提示");
          }
        });
      });
    },
    handleSizeChange(val) {
      this.listQuery.PagingInfo.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.listQuery.PagingInfo.currentPage = val;
      this.getDataList();
    },
    closeDialog() {
      // this.resetObj(this.projectForm);

      this.$refs.projectForm.resetFields();
      this.isEdit = false;
      this.projectTypeVisible = false;
    },
    resetObj(dataObj) {
      for (var i in dataObj) {
        dataObj[i] = "";
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>





// WEBPACK FOOTER //
// src/views/project/project.vue